var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value !== undefined && _vm.value !== null && _vm.value !== '')?_c('AdminBadge',{attrs:{"color":_vm.meta.color,"min-width":44,"title":`${_vm.meta.label} · ${_vm.meta.name}`}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('span',{staticClass:"text-grey-6"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }